import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="site-footer">
      <p>&copy; 2025 每日一果. All Rights Reserved.</p>
      <p>数据来源：公开营养学数据库与相关研究</p>
    </footer>
  );
};

export default Footer;
